import { render, staticRenderFns } from "./VStakeholderCategoryEdit.vue?vue&type=template&id=0b645681&"
import script from "./VStakeholderCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./VStakeholderCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports